const withAnimationFrame = (cb: () => void) => {
  // We wrap it in requestAnimationFrame to avoid this error - ResizeObserver loop limit exceeded
  window.requestAnimationFrame(cb);
};

export default withAnimationFrame;
